export default __webpack_public_path__ + "static/media/Communicate.2980f935.jpg";